import {
    IS_CONTINUE,
    FIFTY_DISCOUNT,
    TEN_DISCOUNT,
    THIRTY_DISCOUNT,
    COMMON,
    LIMIT_OVER,
    DELETE_CONFIRM,
    IS_DELETE_CONTINUE,
    PROHIBITED,
    EXCEL_VALIDATION,
    NBPBKBN,
    PROHIBITED_ITEM,
    SHOW_TABLE_LIMIT_OVER,
    EDLP,
    IS_EDLP_CONTINUE,
    PRICE_VALID,
    IS_PRICE_VALID_CONTINUE,
    BAIKA,
    EXPORT_ERROR,
    VARIANT_PRODUCTS,
    IS_VARIANT_PRODUCTS_CONTINUE,
} from './type';

export const setIsContinue = (data = false) => {
    return {
        type: IS_CONTINUE,
        data: data,
    };
};

export const setFiftyDiscount = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: FIFTY_DISCOUNT,
        data: data,
    };
};

export const setThirtyDiscount = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: THIRTY_DISCOUNT,
        data: data,
    };
};

export const setTenDiscount = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: TEN_DISCOUNT,
        data: data,
    };
};

export const setLimitOver = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: LIMIT_OVER,
        data: data,
    };
};

export const setShowTableLimitOver = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: SHOW_TABLE_LIMIT_OVER,
        data: data,
    };
};

export const setProhibited = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: PROHIBITED,
        data: data,
    };
};

export const setProhibitedItem = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: PROHIBITED_ITEM,
        data: data,
    };
};

export const setNbpbkbn = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: NBPBKBN,
        data: data,
    };
};

export const setExcelValidation = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: EXCEL_VALIDATION,
        data: data,
    };
};

export const setIsDeleteContinue = (data = false) => {
    return {
        type: IS_DELETE_CONTINUE,
        data: data,
    };
};

export const setDeleteConfirm = (data = false) => {
    return {
        type: DELETE_CONFIRM,
        data: data,
    };
};

export const setCommon = (
    data = {
        isShow: false,
        title: '',
        body: '',
    },
) => {
    return {
        type: COMMON,
        data: data,
    };
};

export const setEdlp = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: EDLP,
        data: data,
    };
};

export const setIsEdlpContinue = (data = false) => {
    return {
        type: IS_EDLP_CONTINUE,
        data: data,
    };
};

export const setPriceValid = (
    data = {
        isShow: false,
        title: '',
        items: [],
    },
) => {
    return {
        type: PRICE_VALID,
        data: data,
    };
};

export const setIsPriceValidContinue = (data = false) => {
    return {
        type: IS_PRICE_VALID_CONTINUE,
        data: data,
    };
};

export const setBaika = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: BAIKA,
        data: data,
    };
};

export const setExportError = (
    data = {
        isShow: false,
        title: '',
        text01: '',
    },
) => {
    return {
        type: EXPORT_ERROR,
        data: data,
    };
};

export const setVariantProducts = (
    data = {
        isShow: false,
        items: [],
    },
) => {
    return {
        type: VARIANT_PRODUCTS,
        data: data,
    };
};

export const setIsVariantProductsContinue = (data = false) => {
    return {
        type: IS_VARIANT_PRODUCTS_CONTINUE,
        data: data,
    };
};
